/* Sona World Uniforms: editorial layer. Season bar preview, scroll reveals, the school grid reveal and the Concierge search. */
(function () {
  'use strict';
  var doc = document;
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function $(sel, root) { return (root || doc).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); }
  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').replace(/^ +| +$/g, ''); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function escRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

  /* ---------------------------------------------------------------- season bar: #new-session, #mid-year, #growing preview each message */
  function seasonPreview() {
    var bar = $('[data-ed-season]');
    if (!bar) return;
    var map = { 'new-session': 'new', 'mid-year': 'mid', growing: 'grow' };
    var key = map[(window.location.hash || '').replace('#', '')];
    var msg = $('[data-ed-season-msg]', bar);
    if (key && msg && bar.getAttribute('data-' + key)) msg.textContent = bar.getAttribute('data-' + key);
  }

  /* ---------------------------------------------------------------- scroll reveals */
  function revealAll() {
    var els = $$('.ed-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------------------------------------------------------------- school grid: reveals once, and again when 'Find your school' is clicked */
  var grid = null;
  function gridInit() {
    grid = $('[data-ed-grid]');
    if (!grid) return;
    var sentinel = $('[data-ed-sentinel]') || grid;
    if (reduce || !('IntersectionObserver' in window)) { grid.classList.add('is-in'); return; }
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) { grid.classList.add('is-in'); io.disconnect(); }
    }, { rootMargin: '0px 0px -12% 0px' });
    io.observe(sentinel);
  }
  function headerOffset() {
    var h = $('.section-header');
    return h ? h.offsetHeight : 72;
  }
  function browse() {
    var sec = $('#schools');
    if (!sec) { window.location.href = (window.shopUrl || '') + '/#schools'; return; }
    closeConc();
    if (grid) grid.classList.remove('is-in');
    var top = sec.getBoundingClientRect().top + window.pageYOffset + (window.innerWidth < 768 ? 16 : 80) - headerOffset();
    window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
    setTimeout(function () { if (grid) { void grid.offsetWidth; grid.classList.add('is-in'); } }, reduce ? 0 : 520);
  }
  function bindFind() {
    $$('[data-ed-find]').forEach(function (a) {
      a.addEventListener('click', function (e) { if ($('#schools')) { e.preventDefault(); browse(); } });
    });
  }

  /* ---------------------------------------------------------------- concierge */
  var conc, input, list, none, scrim, closeBtn, items = [], active = 0, schools = [];
  function readSchools() {
    schools = $$('[data-ed-school]').map(function (li) {
      return {
        name: li.getAttribute('data-name') || '',
        area: li.getAttribute('data-area') || '',
        url: li.getAttribute('data-url') || '#',
        hay: norm((li.getAttribute('data-name') || '') + ' ' + (li.getAttribute('data-area') || '') + ' ' + (li.getAttribute('data-hay') || ''))
      };
    });
  }
  function search(q) {
    var toks = norm(q).split(' ').filter(Boolean);
    if (!toks.length) return schools;
    return schools.filter(function (s) { return toks.every(function (t) { return s.hay.indexOf(t) !== -1; }); });
  }
  function mark(text, q) {
    var toks = norm(q).split(' ').filter(Boolean).sort(function (a, b) { return b.length - a.length; });
    var safe = esc(text);
    if (!toks.length) return safe;
    var re = new RegExp('(' + toks.map(function (t) { return escRe(esc(t)); }).join('|') + ')', 'ig');
    return safe.replace(re, '<mark class="ed-mark">$1</mark>');
  }
  var arrowR = '<svg class="ed-arrow" width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="square" aria-hidden="true"><path d="M2 8h11M8.5 3.5 13 8l-4.5 4.5"/></svg>';
  function render() {
    var q = input.value;
    var found = search(q);
    var shown = q.replace(/\s/g, '') ? found : found.slice(0, 5);
    list.innerHTML = shown.map(function (s, i) {
      return '<li role="option" id="ed-opt-' + i + '" aria-selected="false"><a class="ed-conc__item" style="--i:' + i + '" tabindex="-1" href="' + esc(s.url) + '"><span><span class="ed-conc__name">' + mark(s.name, q) + '</span>' + (s.area ? '<span class="ed-conc__area">' + mark(s.area, q) + '</span>' : '') + '</span>' + arrowR + '</a></li>';
    }).join('');
    items = $$('.ed-conc__item', list);
    none.hidden = shown.length > 0;
    if (!shown.length) none.textContent = 'No school matches “' + q.replace(/^\s+|\s+$/g, '') + '”. Check the spelling, or browse every school below.';
    setActive(0);
    items.forEach(function (a, i) {
      a.addEventListener('mouseenter', function () { setActive(i); });
    });
  }
  function setActive(i) {
    active = Math.max(0, Math.min(i, items.length - 1));
    items.forEach(function (a, n) {
      a.classList.toggle('is-active', n === active);
      a.parentNode.setAttribute('aria-selected', n === active ? 'true' : 'false');
    });
    if (items[active]) input.setAttribute('aria-activedescendant', 'ed-opt-' + active); else input.removeAttribute('aria-activedescendant');
  }
  function openConc() {
    if (!conc || conc.classList.contains('is-open')) return;
    conc.classList.add('is-open');
    input.setAttribute('aria-expanded', 'true');
    input.placeholder = (window.innerWidth < 640 && input.getAttribute('data-expanded-mobile')) || input.getAttribute('data-expanded') || input.placeholder;
    closeBtn.hidden = false;
    if (scrim) scrim.classList.add('is-on');
    render();
    // Keep the whole list in view when the search sits low on the screen.
    var r = conc.getBoundingClientRect();
    var need = r.top + 56 + 440 - window.innerHeight;
    if (need > 0) window.scrollBy({ top: Math.min(need + 24, Math.max(0, r.top - headerOffset() - 16)), behavior: reduce ? 'auto' : 'smooth' });
  }
  function closeConc() {
    if (!conc || !conc.classList.contains('is-open')) return;
    conc.classList.remove('is-open');
    input.setAttribute('aria-expanded', 'false');
    input.removeAttribute('aria-activedescendant');
    input.placeholder = input.getAttribute('data-collapsed') || 'Search';
    closeBtn.hidden = true;
    if (scrim) scrim.classList.remove('is-on');
    input.blur();
  }
  function concInit() {
    conc = $('[data-ed-conc]');
    if (!conc) return;
    input = $('[data-ed-conc-input]', conc);
    list = $('[data-ed-conc-list]', conc);
    none = $('[data-ed-conc-none]', conc);
    closeBtn = $('[data-ed-conc-close]', conc);
    scrim = $('[data-ed-scrim]');
    readSchools();
    if (!schools.length || !input) return;
    var form = $('[data-ed-conc-form]', conc);
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); if (items[active]) window.location.href = items[active].getAttribute('href'); });
    input.addEventListener('focus', openConc);
    input.addEventListener('click', openConc);
    input.addEventListener('input', function () { openConc(); render(); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); closeConc(); }
      else if (e.key === 'ArrowDown') { e.preventDefault(); openConc(); setActive(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
    });
    closeBtn.addEventListener('click', closeConc);
    if (scrim) scrim.addEventListener('click', closeConc);
    var b = $('[data-ed-browse]', conc);
    if (b) b.addEventListener('click', function () { input.value = ''; browse(); });
    doc.addEventListener('pointerdown', function (e) { if (conc.classList.contains('is-open') && !conc.contains(e.target)) closeConc(); });
  }

  function init() {
    seasonPreview();
    revealAll();
    gridInit();
    bindFind();
    concInit();
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
})();